module.exports = __webpack_public_path__ + "static/media/calendar2.c8392f9c.svg";